export default {
      id: "ic_jockey_star-usage",
      viewBox: "0 0 8 8",
      url: "/" + "images/icons.3.109.2.svg#ic_jockey_star-usage",
      toString: function () {
        return this.url;
      }
    }